import { useRouter } from 'next/router';
import { useMemo, useRef } from 'react';
import { getAppScope } from '../utils/get-app-scope';
import { AppScopeContext } from './app-scope-context';

export const AppScopeProvider: React.FC<React.PropsWithChildren> = (props) => {
  const router = useRouter();

  const firstPageRoute = useRef<string>(router.pathname).current;

  const memoizedValue = useMemo(() => {
    const appScope = getAppScope(firstPageRoute);

    return {
      appScope,
    };
  }, [firstPageRoute]);

  return <AppScopeContext.Provider {...props} value={memoizedValue} />;
};

export const withAppScopeProvider = <P extends object>(Component: React.ComponentType<P>) => {
  const WrappedComponent: React.FC<P> = (props) => {
    return (
      <AppScopeProvider>
        <Component {...props} />
      </AppScopeProvider>
    );
  };

  return WrappedComponent;
};
